<!-- eslint-disable vuejs-accessibility/no-static-element-interactions -->
<!-- eslint-disable vuejs-accessibility/click-events-have-key-events -->
<template>
  <div>
    <div
      class="bg-overlay-low fixed inset-x-0 bottom-0 top-[115px] opacity-70"
      @click.self="toggle"
    />
    <section class="fixed bottom-0 top-[115px] p-0">
      <nav
        class="bg-surface-default-low absolute bottom-[7rem] top-0 h-auto w-256 overflow-hidden pt-16"
      >
        <div
          class="flex h-full flex-col gap-16 overflow-hidden hover:overflow-auto"
        >
          <template v-for="item in menu" :key="item.title">
            <RevLink
              class="flex items-center pl-32"
              data-test="store-nav-list-item"
              :style="item.style?.text_color"
              :to="item.link"
              :underlined="false"
              @focusin="select(item)"
              @focusout="reset"
              @mouseleave="reset"
              @mouseover="select(item)"
            >
              {{ item.title }}
            </RevLink>
            <hr class="border-static-default-low" />
          </template>
        </div>
      </nav>
      <MenuFooter class="absolute bottom-0 w-256" />
    </section>

    <MenuPanel
      v-if="selected"
      class="bg-surface-default-low fixed bottom-0 left-256 top-[115px] w-[50rem] pt-0"
      :item="selected"
    />
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'

import type { navigationAPI } from '@backmarket/http-api'
import { RevLink } from '@ds/components/Link'

import { useNavigation } from '../composables/useNavigation'

import MenuFooter from './MenuFooter.vue'
import MenuPanel from './MenuPanel.vue'

const { menu, toggle } = useNavigation()

const selected = ref<navigationAPI.MenuItem | undefined>(undefined)

let delay: ReturnType<typeof setTimeout>
function select(item: navigationAPI.MenuItem) {
  delay = setTimeout(() => {
    selected.value = item
  }, 100)
}

function reset() {
  clearTimeout(delay)
}
</script>
